var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "family-success tongxin-layout"
  }, [_c('div', {
    staticClass: "success-content"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_c('svg', {
    staticClass: "checkmark",
    attrs: {
      "viewBox": "0 0 52 52"
    }
  }, [_c('circle', {
    staticClass: "checkmark-circle",
    attrs: {
      "cx": "26",
      "cy": "26",
      "r": "25",
      "fill": "none"
    }
  }), _c('path', {
    staticClass: "checkmark-check",
    attrs: {
      "fill": "none",
      "d": "M14.1 27.2l7.1 7.2 16.7-16.8"
    }
  })])]), _c('h1', {
    staticClass: "success-title"
  }, [_vm._v(_vm._s(_vm.successTitle))]), _c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "btn btn-primary w-100 mb-3",
    on: {
      "click": _vm.goToFamilyList
    }
  }, [_vm._v(" 回家庭成員頁 ")]), _c('button', {
    staticClass: "btn btn-secondary w-100",
    on: {
      "click": _vm.goToLineOA
    }
  }, [_vm._v(" 回 LINE 對話框 ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }